import { Container, Row, Col } from 'react-bootstrap'
import TravelResultItemTile from '@/components/models/travel/filter/TravelFilterResultList/TravelResultItemTile'
import { useAppSelector } from '@/app/hooks'
import { selectTravelFilter } from '@/features/travelFilter'
import { TravelFilterTravel } from '@/features/travelFilter/types'
import { useEffect, useState } from 'react'
import TravelFilterPartnerHint from '@/components/models/travel/filter/TravelFilterPartnerHint'

interface Props {
  travels?: TravelFilterTravel[]
  immutable?: boolean
  className?: string
  trackingStringPrefix: string
}

const TravelFilterResultList = ({ travels: initialTravels, immutable = false, className = '', trackingStringPrefix }: Props) => {
  const filterState = useAppSelector(selectTravelFilter)
  const [travels, setTravels] = useState<TravelFilterTravel[]>(initialTravels ? initialTravels : filterState.travels)

  useEffect(() => {
    if (immutable) {
      if (initialTravels && initialTravels.length > 0) {
        setTravels(initialTravels)
      }
    } else {
      setTravels(filterState.travels)
    }
  }, [filterState.travels, initialTravels, immutable])

  return (
    <Container className={className}>
      <Row>
        {travels.map((travel: any, index: number) => {
          return (
            <Col key={index} md={6} lg={4} xxl={3} className={'mb-3'}>
              <TravelResultItemTile travel={travel} trackingStringPrefix={trackingStringPrefix} />
            </Col>
          )
        })}
      </Row>
      <TravelFilterPartnerHint trackingStringPrefix={trackingStringPrefix} />
    </Container>
  )
}

export default TravelFilterResultList
